import { useEffect, useCallback, useRef } from 'react';

const ActionListeners = ({ eventEmitter, applyStoreAction, currentUserId }) => {
    const timers = useRef({});

    const messageTypingStart = useCallback(({ user_id: userId, id: discussionId }) => {
        if (currentUserId === userId) {
            return;
        }

        applyStoreAction({
            type: 'USER_ACTION_TYPING_START',
            payload: { userId, discussionId }
        });

        const timerKey = discussionId + userId;

        if (timers.current[timerKey]) {
            clearTimeout(timers.current[timerKey]);
        }

        timers.current[timerKey] = setTimeout(() => {
            applyStoreAction({
                type: 'USER_ACTION_TYPING_END',
                payload: { userId, discussionId }
            });

            timers.current[timerKey] = null;
        }, 10 * 1000);
    }, [currentUserId, applyStoreAction]);

    const messageTypingEnd = useCallback(({ user_id: userId, id: discussionId }) => {
        if (currentUserId === userId) {
            return;
        }

        applyStoreAction({
            type: 'USER_ACTION_TYPING_END',
            payload: { userId, discussionId }
        });
    }, [currentUserId, applyStoreAction]);

    const listen = () => {
        eventEmitter.on('message_typing_start', messageTypingStart);
        eventEmitter.on('message_typing_end', messageTypingEnd);

        return () => {
            eventEmitter.off('message_typing_start', messageTypingStart);
            eventEmitter.off('message_typing_end', messageTypingEnd);
        };
    };

    useEffect(listen, [eventEmitter, messageTypingStart, messageTypingEnd]);

    return null;
}

export default ActionListeners;
